import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Protege el login: un usuario que ya tiene sesión se manda al dashboard en vez de ver el formulario.
 *
 * La sesión se considera válida si el access token sigue vigente o si hay un refresh token sin caducar
 * (el interceptor renovará el access token en la primera petición).
 * @param _route - Ruta destino; no se usa.
 * @param _state - Estado del router; no se usa.
 * @returns `false` (tras navegar a `/dashboard`) si hay sesión válida; `true` si no la hay.
 */
export const publicGuard: CanActivateFn = (_route, _state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const hasValidSession =
        (authService.isLoggedIn() && !authService.isTokenExpired()) ||
        (!!authService.getRefreshToken() && !authService.isRefreshTokenExpired());

    if (hasValidSession) {
        router.navigate(['/dashboard']);
        return false;
    }
    return true;
};
